import { useContractOrdererStore } from '@/hooks/use-contract-orderer'
import classNames from 'classnames'
import { useI18n } from 'i18n-utils'
import { ApiStatus, ContractServices } from 'network'
import { ArrowDownIcon, CustomButton, DialogHeader, HocElDialog, HocElDialogFooterLayout, UiUtils, useDialog } from 'ui-components'
import '../styles/position-type-layout.scss'

export const PositionType = defineComponent({
  setup() {
    const orderer = useContractOrdererStore()
    const { t } = useI18n()
    const { openDialog, closeDialog, dialogVisible } = useDialog()
    const tempSelectIndex = ref(0)
    const loading = ref(false)
    const onOpenDialog = () => {
      openDialog()
    }

    const types = ['逐仓', '全仓']

    const typesDetail = [
      '根据用户操作一定数量保证金被分配到仓位上，如果仓位亏损到低于维持保证金的水平，仓位将被强平。在逐仓模式下，用户可以自行追加保证金。',
      '仓位保证金将共享全部同币种账户资产，如果仓位亏损低于一定比例，全仓系统将自动追加可用保证金。在强平事件中，交易者可能会损失全部保证金和账户资产。',
    ]

    const titleList = ['逐仓模式', '全仓模式']

    const onClose = () => {
      closeDialog()
    }

    const onConfirm = async () => {
      loading.value = true
      const res = await ContractServices.doubleContractUpdateMarginType({
        symbolId: orderer.currentSymbolId!,
        marginType: tempSelectIndex.value === 0 ? 1 : 2,
      })
      loading.value = false
      if (res.status === ApiStatus.Success) {
        UiUtils.showSuccess(t('设置成功'))
        closeDialog()
      }
    }

    watch(
      () => orderer.isIsolated,
      (newVal) => {
        tempSelectIndex.value = newVal ? 0 : 1
      },
      {
        immediate: true,
      },
    )

    return () => (
      <>
        <div class="position-type-layout" onClick={onOpenDialog}>
          {orderer.isIsolated ? t('逐仓') : '全仓'}
          <ArrowDownIcon />
        </div>
        <HocElDialog v-model={dialogVisible.value} showClose={false} width={430} onClose={onClose}>
          {{
            header: () => <DialogHeader onClose={onClose}>{t('保证金模式')}</DialogHeader>,
            default: () => (
              <div class="position-type-dialog">
                <div class="preference-items">
                  {types.map((item, index) => (
                    <div class={classNames('preference-item', { active: tempSelectIndex.value === index })} key={index} onClick={() => (tempSelectIndex.value = index)}>
                      {t(item)}
                    </div>
                  ))}
                </div>
                <div class="preference-detail">
                  {typesDetail.map((item, index) => (
                    <p class="preference-detail-item" key={index}>
                      <span class="preference-detail-item-title">*{t(titleList[index])}:</span>
                      <span class="preference-detail-item-desc">{t(item)}</span>
                    </p>
                  ))}
                </div>
              </div>
            ),
            footer: () => (
              <HocElDialogFooterLayout>
                <CustomButton class="confirm-btn" type={'primary'} loading={loading.value} onClick={onConfirm}>
                  {t('确认')}
                </CustomButton>
              </HocElDialogFooterLayout>
            ),
          }}
        </HocElDialog>
      </>
    )
  },
})
